import { defineComponent, h } from 'vue';
import { TodoIssueRecord } from '@/entities/issue';
import { Modal } from '@/ui/components/Modal';
import { pageSubtitle } from '@/ui/components';
import { issueEditWithLogs } from '@/ui/pages/issue/issueEditWithLog/IssueEditWithLogs';
import { Button } from '@/ui/components/Button';
import { t } from '@/ui/i18n/i18n';
import { VNodeData } from 'vue/types/vnode.d';

interface EditIssueProps {
  issue: TodoIssueRecord;
  loading: boolean;
}

export const EditIssueModal = defineComponent<EditIssueProps>({
  name: 'EditIssueModal',
  props: ['issue', 'loading'],
  setup(props, context) {
    return function render() {
      const closeModal = () => {
        context.emit('close');
      };

      const onIssueUpdateClick = () => {
        context.emit('update:click:issue');
      };

      const onIssueUpdated = () => {
        context.emit('updated:issue');
      };

      return h(Modal, {
        props: {
          active: true,
          ariaRole: 'dialog',
          trapFocus: true,
          destroyOnHide: false,
          ariaModal: true,
          hasPrimaryBackgroundColor: true,
          width: '960px',
          canCancel: ['x'],
        },
        on: {
          close: closeModal,
        },
        scopedSlots: {
          actions: () => [
            h(Button, {
              props: { type: 'is-text', btnClass: 'mr-2 has-text-weight-semibold' },
              on: { click: closeModal },
            }, t('modal.cancel')),
            h(Button, {
              props: {
                loading: props.loading,
              },
              on: { click: onIssueUpdateClick },
            }, t('issues.update')),
          ],
        },
      }, [
        pageSubtitle(t('inspections.raise-issue')),
        issueEditWithLogs({
          props: {
            issueId: props.issue.id,
            hideSendButton: true,
            approvalId: props.issue.data.issue?.approval?.id,
          },
          on: { 'edit:issue': onIssueUpdated },
        }),
      ]);
    };
  },
});

export function editIssue(data: VNodeData & { props: EditIssueProps }) {
  return h(EditIssueModal, data);
}
